import { useEffect, useState } from 'react';

/** Débounce une valeur (recherche, mission S3-a point 2), 300 ms par défaut. */
export function useDebounce<T>(valeur: T, delaiMs = 300): T {
  const [debattue, setDebattue] = useState(valeur);

  useEffect(() => {
    const identifiant = window.setTimeout(() => setDebattue(valeur), delaiMs);
    return () => window.clearTimeout(identifiant);
  }, [valeur, delaiMs]);

  return debattue;
}
